import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";

type ContentProps = {
  setSelectedOption: any;
  selectedOption: any;
  setSelectedImage: any;
  selectedImage?: any;
};
/**
 * ContentModalPayment
 *
 * این کامپوننت جهت نمایش گزینه‌های پرداخت (کیف پول یا درگاه پرداخت) و همچنین
 * لیست درگاه‌ها یا سرویس‌های قابل انتخاب برای پرداخت طراحی شده است.
 *
 * کاربر می‌تواند:
 * - روش پرداخت مورد نظر خود را انتخاب کند.
 * - یکی از سرویس‌دهنده‌های پرداخت را از میان گزینه‌های نمایش داده شده برگزیند.
 *
 * @param setSelectedOption تابع به‌روزرسانی گزینه انتخابی پرداخت
 * @param selectedOption گزینه انتخاب‌شده توسط کاربر (کیف پول یا درگاه)
 * @param setSelectedImage تابع ذخیره‌سازی سرویس پرداخت انتخاب‌شده
 *
 * @returns JSX.Element
 */
const ContentModalPayment = (props: ContentProps) => {
  const { selectedOption, setSelectedOption, setSelectedImage, selectedImage } = props;

  const arrayImage = [
    { id: 1, title: "fanava", img: "/fanavar.png", name: "فن آوا" },
    // { id: 2, title: "aap", img: "/aap.png", name: "آپ" },
    // { id: 3, title: "vandar", img: "/vandar2.png", name: "وندار" },
    // { id: 4, title: "pariz", img: "/pariz.png", name: "پاریزپی" },
  ];

  const imageStyle = {
    width: "100%",
    maxWidth: "80px",
    filter: selectedOption === "option1" ? "grayscale(2)" : "none",
    transition: "filter 0.3s ease-in-out",
  };

  return (
    <Grid container sx={{ overflow: "hidden" }}>
      <StackKit gap={2}>
        <TypoGraphyKit variant="body1">پذیرنده گرامی</TypoGraphyKit>

        <TypoGraphyKit variant="body1">
          در این بخش شما میتوانید مبلغ مورد نظر خود را جهت افزایش موجودی هدیه وارد کنید.
        </TypoGraphyKit>

        <RadioGroup value={selectedOption} onChange={(e) => setSelectedOption(e.target.value)} sx={{ gap: 2, width: "100%" }}>
          <StackKit direction="column" gap={1}>
            <FormControlLabel value="option1" control={<Radio sx={{ color: "white" }} />} label={<TypoGraphyKit sx={{ color: "white" }}>پرداخت از کیف پول</TypoGraphyKit>}/>
            <FormControlLabel value="option2" control={<Radio sx={{ color: "white" }} />} label={<TypoGraphyKit sx={{ color: "white" }}>پرداخت از درگاه</TypoGraphyKit>}/>
          </StackKit>
        </RadioGroup>

        {/* Image Select Box */}
        <StackKit direction={{ xs: "column", sm: "row" }} justifyContent={{ xs: "center", sm: "space-between" }} alignItems="center" sx={{ width: "100%", gap: 2 }}>
          {arrayImage.map((src) => {
            const isSelected = selectedImage?.id === src.id;

            return (
              <StackKit key={src.id} justifyContent="center" alignItems="center" onClick={() => setSelectedImage(src)}
                sx={{
                  background:"linear-gradient(135.81deg, rgba(255, 255, 255, 0.4) -16.35%, rgba(255, 255, 255, 0.92) 45.35%, rgba(255, 255, 255, 0.1) 131.6%)",
                  borderRadius: "12px",
                  width: { xs: "48%", sm: "23%" },
                  padding: "12px",
                  cursor: "pointer",
                  border: selectedOption !== "option1" && isSelected ? "2px solid #4A90E2" : "2px solid transparent",
                  boxShadow: selectedOption !== "option1" && isSelected ? "0 0 12px rgba(74,144,226,0.7)" : "none",
                  transform: selectedOption !== "option1" && isSelected ? "scale(1.05)" : "scale(1)",
                  transition: "all 0.25s ease-in-out",
                }}
              >
                <img src={src.img} alt={src.title} style={imageStyle}/>
              </StackKit>
            );
          })}
        </StackKit>
      </StackKit>
    </Grid>
  );
};

export default ContentModalPayment;